import { MshNodeEnv } from '@beecode/msh-node-env';
import { PrefixName } from '@beecode/msh-node-env/lib/naming/prefix-name';
import { cacheUtil } from '@beecode/msh-node-util/lib/cache-util';

const env = MshNodeEnv({ namingStrategies: [new PrefixName('REACT_APP_')] });
const sentryEnabled = env('SENTRY_ENABLED').boolean.default(false).required;

export const config = cacheUtil.singleton(() => {
	return Object.freeze({
		logLevel: env('LOG_LEVEL').string.default('error').allowed('error', 'warn', 'info', 'debug').required as
			| 'error'
			| 'warn'
			| 'info'
			| 'debug',
		sentry: sentryEnabled && {
			dsn: env('SENTRY_DSN').string.required,
			sampleRate: env('SENTRY_TRACES_SAMPLE_RATE').number.required,
			replaysSessionSampleRate: env('SENTRY_REPLAYS_SESSION_SAMPLE_RATE').number.default(1).required,
			replaysOnErrorSampleRate: env('SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE').number.default(1).required,
		},
	});
});
